import React, { Component } from 'react';
import { Link, withRouter } from "react-router-dom";

import config from './../config';

class AbendingForm extends Component {
	constructor(props) {
		super(props);

		this.grecaptchaKey = '6LfSlPcZAAAAAI3z5KSf4g7sukQIKnBqvWCF6orm';
		this.apiUrl = config.apiRoot+'/abending/';

		this.formInputChangeHandler = this.formInputChangeHandler.bind(this);
		this.sendButtonClickHandler = this.sendButtonClickHandler.bind(this);

		this.state = {
			formData: {
				nafn: '',
				netfang: '',
				simanumer: '',
				skilabod: ''
			},
			formOpen: false,
			grecaptchaResponse: false,
			formSuccess: false
		}
	}

	formInputChangeHandler(event) {
		let value = event.target.type && event.target.type == 'checkbox' ? event.target.checked : event.target.value;

		let formData = this.state.formData;

		formData[event.target.name] = value;

		this.setState({
			formData: formData
		});
	}

	validateForm() {
		let validationError = [];
		if (this.state.formData.nafn &&
			this.state.formData.netfang &&
			this.validateEmail(this.state.formData.netfang) &&
			this.state.formData.skilabod
		) {
			this.setState({
				validationError: []
			});

			return true;
		}
		else {
			if (!this.state.formData.nafn || !this.state.formData.skilabod) {
				validationError.push(this.props.messageErrorText || 'Þú verður að skrifa nafnið þitt og skilaboð.');
			}
			if (!this.state.formData.netfang || !this.validateEmail(this.state.formData.netfang)) {
				validationError.push(this.props.emailErrorText || 'Þú verður að skrifa gilt netfang.');
			}

			//if (this.state.formData.netfang && !nyyrdiHelper.validateEmail(this.state.formData.netfang)) {
			//	validationError.push('Þú verður að skrifa gilt netfang.');
			//}

			this.setState({
				validationError: validationError
			});

			return false;
		}
	}

	prepareData(data) {
		let ret = {};

		for (let key in data) {
			ret[key] = data[key];
		}

		return ret;
	}

	sendButtonClickHandler(event) {
		event.preventDefault();

		if (this.validateForm()) {
			let formDataValues = new FormData();
			let formData = this.prepareData(this.state.formData);

			for (var key in formData) {
			    formDataValues.append(key, formData[key]);
			}

			formDataValues.append('entity_type', this.props.entityType);
			formDataValues.append('entity_id', this.props.entityId);
			formDataValues.append('entity_name', this.props.entityName);
			formDataValues.append('recaptcha', this.state.grecaptchaResponse);

			fetch(this.apiUrl, {
				method: 'post',
				body: formDataValues,
				mode: 'cors'
			})
			.then(function(response) {
				return response.json();
			}.bind(this))
			.then(function(json) {
				if (json.error) {
					this.setState({
						validationError: [this.props.requestErrorText || 'Villa í fyrirspurn.']
					});
				}
				else if (json.success) {
					this.setState({
						validationError: [],
						formSuccess: true
					});
				}
			}.bind(this));
		}
	}

	componentDidMount() {
		// Undirbúum grecaptcha
			// Skilgreinum fall sem kallað er á þegar svör berast frá Google reCaptcha API
		window.grecaptchaCallback = this.grecaptchaCallback.bind(this);

		// Frumstillum reCaptcha til að sjá til þess að virknin verði til staðar síðar meir
		this.initializeReCaptcha();
	}

	componentWillUnmount() {
		window.reCaptchaInitialized = false;
	}

	grecaptchaCallback(event) {
		this.setState({
			grecaptchaResponse: event
		});
	}

	initializeReCaptcha() {
		if (window.reCaptchaInitialized) {
			return;
		}

		let grcInit = function() {
			try {
				if (window.grecaptcha) {
					window.grecaptcha.render('grecaptcha', {
						callback: window.grecaptchaCallback
					});

					window.reCaptchaInitialized = true;
				}
			}
			catch (e) {
				setTimeout(grcInit, 500);
			}
		}.bind(this);

		grcInit();
	}

	validateEmail(email) {
		var re = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
		return re.test(String(email).toLowerCase());
	}

	render() {
		return (
			<div className="card contact-form">
				<div className="card-body">
					{
						!this.state.formOpen &&
						<React.Fragment>
							<p className="small">Hér er hægt að senda ábendingu varðandi örnefnaskrár, bæi eða einstaklinga.</p>
							<button className="btn btn-secondary" onClick={() => this.setState({formOpen: true})}>Senda ábendingu</button>
						</React.Fragment>
					}
					{
						this.state.formOpen &&
							<React.Fragment>
								{
									this.props.children
								}
								<form className="position-relative">

									<div className="form-group">
										<label htmlFor="nafn">{'Nafn'}</label>
										<input type="text"
											value={this.state.formData.nafn}
											onChange={this.formInputChangeHandler}
											className="form-control"
											name="nafn"
											id="nafn" />
									</div>

									<div className="form-group">
										<label htmlFor="netfang">{'Netfang'}</label>
										<input type="email"
											value={this.state.formData.netfang}
											onChange={this.formInputChangeHandler}
											className="form-control"
											name="netfang"
											id="netfang" />
									</div>

									<div className="form-group">
										<label htmlFor="simanumer">{'Símanúmer (valfrjálst)'}</label>
										<input type="tel"
											value={this.state.formData.simanumer}
											onChange={this.formInputChangeHandler}
											className="form-control"
											name="simanumer"
											id="simanumer" />
									</div>

									<div className="form-group">
										<label htmlFor="skilabod">{'Skilaboð'}</label>
										<textarea className="form-control"
											onChange={this.formInputChangeHandler}
											name="skilabod"
											id="skilabod"
											rows="5" value={this.state.formData.skilabod}></textarea>
									</div>

									<div id="grecaptcha"
										className="g-recaptcha mb-3"
										data-sitekey={this.grecaptchaKey}></div>

									{
										this.state.validationError && this.state.validationError.length > 0 &&
										<p><strong dangerouslySetInnerHTML={{__html: this.state.validationError.join('<br/>')}}></strong></p>
									}

									<button disabled={!this.state.grecaptchaResponse} type="submit" className="btn btn-primary" onClick={this.sendButtonClickHandler}>{this.props.buttonLabel || 'Senda'}</button>

									{
										this.state.formSuccess &&
										<div className="position-absolute d-flex justify-content-center" style={{
											top: 0,
											left: 0,
											right: 0,
											bottom: 0,
											padding: 40,
											backgroundColor: '#fff'
										}}>
											<div className="align-self-center align-self-middle text-center">
												<h3>{'Takk fyrir'}</h3>
												<p>{'Við höfum móttekið ábendinguna frá þér og munum hafa samband ef þörf er á.'}</p>
											</div>

										</div>
									}

								</form>
							</React.Fragment>
					}
				</div>
			</div>
		);
	}
}

export default AbendingForm;



// WEBPACK FOOTER //
// ./src/components/AbendingForm.js